// @flow

import { envConfig } from '../env'
import { getCurrentUserAsync } from '../models/User'
import { Purchases } from '@revenuecat/purchases-js'
import type { UserType } from '../flowTypes'

export async function getManagementUrlAsync (): Promise<string | null> {
  const currentUser: UserType = await getCurrentUserAsync()
  if (currentUser.id) {
    const userId = currentUser.id
    const purchases = Purchases.configure(envConfig().REVENUECAT_API_KEY, userId)
    const customerInfo = await purchases.getCustomerInfo()
    return customerInfo.managementURL
  }
  return null
}
